// StockReco.js - Main page (Lot ID listing)

import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

function StockReco() {
  const [data, setData] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const navigate = useNavigate();

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchStockReco = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/get-StockReco");
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching Red Process data:", error);
    }
  }, []);

  useEffect(() => {
    fetchStockReco();
  }, [fetchStockReco]);

  // Get unique LotID rows
  const groupedData = Object.values(
    data.reduce((acc, row) => {
      if (!acc[row.LotID]) acc[row.LotID] = row;
      return acc;
    }, {})
  );

  const columns = [
    {
      name: "Lot ID",
      selector: row => (
        <a
          onClick={() => navigate(`/lot/${encodeURIComponent(row.LotID)}`)}
          style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
        >
          {row.LotID}
        </a>
      )
    },
    {
      name: "Date",
      selector: row => {
        if (!row.SyncDate) return "—";
        const date = new Date(row.SyncDate);
        return date.toISOString().split("T")[0];
      }
    }
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4">
          <div className="mt-0">
            <h3 className="mb-4">Stock Reco (Lot-wise View)</h3>
            <DataTable
              columns={columns}
              data={groupedData}
              pagination
              highlightOnHover
            />
          </div>
        </main>
      </div>
    </div>
  );
}

export default StockReco;
